<script>
export default {
	name: 'BrowserAlert',
	props: {
		displayCard: {
			type: Boolean,
			default: false
		},
		showDetails: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		videoInputsExist: false,
		deviceChecker: null,
		deviceCheckComplete: false
	}),
	computed: {
		isiOSDevice: function () {
			const isTouchScreen = navigator.maxTouchPoints > 1
			const isIOS = !!(/iPhone|iPad/i.test(navigator.platform))
			// iPads over version 13 need to be differentiated from other Apple devices
			const isAppleDevice = !!(/MacIntel/i.test(navigator.platform))
			const isIPad = isAppleDevice && isTouchScreen
			return (isIOS || isIPad)
		},
		nativeBrowser: function () {
			return this.isiOSDevice ? 'Safari' : 'Chrome'
		},
		unsupportedBrowser: function () {
			const isUnsupportediOS = !!(/CriOS|FxiOS|Firefox|Line|UCBrowser/i.test(navigator.userAgent))
			const isUnsupportedAndroid = !!(/.*Android.*Line|.*Android.*UCBrowser|.*Android.*Mobile.*Firefox/i.test(navigator.userAgent))
			return isUnsupportedAndroid || (isUnsupportediOS && this.isiOSDevice)
		},
		mediaSupported: function () {
			return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
		},
		compatibleDevice: function () {
			const deviceIsSupported = this.mediaSupported && !this.unsupportedBrowser && (this.videoInputsExist || this.isiOSDevice)
			return this.deviceCheckComplete ? deviceIsSupported : true
		}
	},
	created: function () {
		this.deviceChecker = new Promise((resolve, reject) => {
			if (navigator.mediaDevices) {
				resolve(navigator.mediaDevices.enumerateDevices())
			} else reject(new Error('mediaDevices is undefined'))
		}).then((response) => {
			this.videoInputsExist = response.filter((device) => {
				return device.kind.indexOf('video') >= 0
			}).length > 0
		}).catch(() => {
			this.videoInputsExist = false
		}).finally(() => {
			this.deviceCheckComplete = true
			// disable auto-scroll if alert is shown
			if (!this.compatibleDevice) this.$store.commit('enrollmentCard/setEventStack', null)
			this.$emit('compatible-device', this.compatibleDevice)
		})
	}
}
</script>

<template>
	<div class="browser-alert" v-if="!compatibleDevice"
		:class="{ 'browser-alert__card' : displayCard }" >
		<div class="browser-alert__header" :class="{ 'browser-alert__header--row' : !showDetails }">
			<font-awesome-icon class="browser-alert__icon" :icon="['fas', 'exclamation-circle']"
				:class="{ 'browser-alert__icon--danger browser-alert__icon--row' : !showDetails }" />
			<div class="browser-alert__title" :class="{ 'browser-alert__title--small' : !showDetails }">
				<span v-html="$t('commonMsg.browserNotSupported')"/>
				<span v-if="!showDetails" v-html="$t('commonMsg.switchBrowser.compact', { browser: nativeBrowser })"></span>
			</div>
		</div>
		<div class="browser-alert__content" v-show="showDetails">
			<span class="browser-alert__content--padding" v-html="$t('commonMsg.switchBrowser.detailed', { browser: nativeBrowser })"></span>
			<div class="browser-alert__callout">
				<font-awesome-icon class="browser-alert__icon--muted browser-alert__icon--small browser-alert__icon--row"
					:icon="['fas','external-link-alt']" />
				<p v-html="$t('commonMsg.switchBrowser.callout')"></p>
			</div>
			<slot />
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.browser-alert {
		background-color: white;
		color: var(--text-colour);
		height: 100%;
		width: 100%;

		&__card {
			max-width: 500px;
			border-radius: var(--border-radius);
			margin: 2rem auto;
			@media (max-width: 450px) {
				border-radius: 0;
			}
		}

		&__header {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin: 0 auto;
			padding: 2rem 2rem 1rem 2rem;
			width: 100%;
			max-width: var(--default-container-width);

			&--row {
				flex-direction: row;
				justify-content: flex-start;
			}
		}

		&__title {
			font-weight: bold;
			font-size: 1.2rem;
			margin-bottom: 1rem;
			@media (max-width: 450px) {
				font-size: 5vw;
			}

			&--small {
				margin-bottom: 0;
				font-size: 1.1rem;
				@media (max-width: 600px) {
					font-size: 1rem;
				}
			}
		}

		&__content {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding-bottom: 2rem;
			@media (max-width: 450px) {
				font-size: 4vw;
			}
			&--padding {
				padding: 0 2rem 1rem 2rem;
			}
		}

		&__icon {
			font-size: 3rem;
			margin-bottom: 1rem;

			&--danger {
				color: var(--danger-colour);
			}

			&--muted {
				color: #6f6f6f;
			}

			&--row {
				margin-bottom: 0;
				margin-right: 2rem;
				@media (max-width: 600px) {
					margin-right: 1rem;
				}
			}

			&--small {
				font-size: 1.75rem;
			}
		}

		&__callout {
			align-items: center;
			background-color: #FFF6A6;
			color: #3b3b3b;
			display: flex;
			font-size: 0.9rem;
			padding: 1rem 2rem;
		}
	}
</style>
